<template>
  <div id="main-box">
    <toolbar
      id="btn-box"
      :buttonList="buttonList_toolBar"
      @callFunction="callFunction"
    ></toolbar>
    <div id="content-box">
      <el-card>
        <el-table
          :data="tableList"
          highlight-current-row
          v-loading="tableLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          @current-change="selectCurrentRow"
          style="width: 100%"
          border
        >
          <el-table-column
            prop="id"
            label="仓库ID"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="仓库名"
            min-width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="areaString"
            label="仓库地址"
            min-width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            label="发货区域"
            min-width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.showDeliveryArea">{{ scope.row.deliveryAreaStr }}</span>
              <el-button v-if="!scope.row.showDeliveryArea" size="small" type="primary" :loading="scope.row.showLoading" @click="getDeliveryAreasStr(scope.row)">查看</el-button>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" min-width="220" fixed="right">
            <template slot-scope="scope">
              <toolbar
                :buttonList="buttonList_table"
                :funcParams="scope.row"
                @callFunction="callFunction"
              ></toolbar>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          style="float: right"
          :total="total"
          :current-page="queryForm.pageIndex"
          :pageSize="queryForm.pageSize"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </el-card>
    </div>

    <el-dialog
      :title="isEdit ? '编辑' : '新增'"
      :visible.sync="warehouseFormVisible"
      v-if="warehouseFormVisible"
      v-model="warehouseFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="warehouseForm"
        label-width="120px"
        :rules="warehouseFormRules"
        ref="warehouseForm"
      >
        <el-form-item label="仓库名" prop="name">
          <el-input v-model="warehouseForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所在省份" prop="area">
          <el-cascader ref="myCascader"  @change="changeselectedAreaNode" clearable v-model="warehouseForm.area" :props="props"></el-cascader>
        </el-form-item>
        <el-form-item label="仓库详细地址" prop="address">
          <el-input v-model="warehouseForm.address" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="warehouseFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitWarehouse" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <el-dialog
      id="areaSet"
      title="发货区域配置"
      :visible.sync="areaSetFormVisible"
      v-if="areaSetFormVisible"
      v-model="areaSetFormVisible"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form
        :model="areaSetForm"
        label-width="120px"
        :rules="areaSetFormRules"
        ref="warehouseForm"
      >
        <div class="col">
          <el-button @click="allSelArea" size="small" type="primary"
            >全选</el-button
          >
          <el-button @click="clearSelArea" size="small" type="danger"
            >清除</el-button
          >
        </div>

        <el-tree
          :data="areaTreeList"
          show-checkbox
          node-key="id"
          ref="tree"
          highlight-current>
        </el-tree>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="areaSetFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitAreaSet" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  GetAllWarehouse,
  CreateWarehouse,
  GetWarehouseDetail,
  DeleteWarehouse,
  GetAreaTree,
  GetAllArea,
  UpdateDeliveryAreas,
  GetDeliveryAreas
} from "../../api/api";
import toolbar from "../../components/Toolbar";
import {getButtonList} from "../../promissionRouter";
export default {
  components: {toolbar},
  data() {
    let that = this;
    return {
      buttonList_toolBar: [],
      buttonList_table: [],

      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          that.renderAreaCascader(resolve, node.level, node);
        },
      },

      tableList: [],
      tableLoading: false,
      currentRow: null,
      total: 0,
      queryForm: {
        Name: null,
        pageIndex: 1,
        pageSize: 10
      },

      warehouseFormVisible: false,
      isEdit: false,
      warehouseForm: {
        name: null,
        area: null,
        address: null
      },
      warehouseFormRules: {
        name: [
          { required: true, message: '请输入仓库名', trigger: 'blur' },
          { message: '请输入仓库名', trigger: ['blur', 'change'] }
        ],
        area: [
          {type: 'array', required: true, message: '请选择所在省份', trigger:  'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { message: '请输入详细地址', trigger: ['blur', 'change'] }
        ],
      },

      areaSetFormVisible: false,
      isEdit: false,
      areaSetForm: {
        name: null,
        area: null,
        address: null
      },
      areaSetFormRules: {
      },
      
      submitLoading: false,

      areaSetFormVisible: false,
      isEdit: false,
      areaList: [],
      tempArr: [],

      areaTreeList: [],
      checkedArea: []
    };
  },
  created() {
    this.renderAreaCascaderCascaderTree();
  },
  mounted() {
    this.parentId = parseInt(this.$route.query.parentId);
    this.getTableList();
    this.renderButton();
  },
  methods: {
    getDeliveryAreasStr(row) {
      let params = {
        WarehouseId: row.id,
        MaxLevel: 1,
      }
      row.showLoading = true;
      GetDeliveryAreas(params).then((res) => {
        row.showLoading = false;
        row.showDeliveryArea = true;
        row.deliveryAreaStr = res.data.result.join(',');
      });
    },
    allSelArea() {
      this.$refs.tree.setCheckedNodes(this.areaTreeList);
    },
    clearSelArea() {
      this.$refs.tree.setCheckedNodes([]);
    },
    renderAreaCascaderCascaderTree() {
      let params = {
        MaxLevel: 3
      };
      GetAreaTree(params).then((res) => {
        this.areaTreeList = this.loopTree(res.data.result.children);
      });
    },
    loopTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children, item.areaFullId)
        }
        return true;
      })
      return newList;
    },
    renderButton() {
      let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
      var buttonList = getButtonList(this.$route.path, routers);
      this.buttonList_toolBar = buttonList.filter((item) => {
        return item.buttonShow == 10 && item.isVisible;
      });
      this.buttonList_table = this.$utils.sortDataArrayAsc(buttonList.filter((item) => {
        return item.buttonShow == 20 && item.isVisible;
      }), 'order');
    },
    callFunction(item) {
      this[item.buttonFunc](item);
    },
    changeselectedAreaNode() {
      this.selectArea = this.$refs.myCascader.getCheckedNodes()[0].pathNodes;
    },
    renderAreaCascader(resolve, level, node) {
      let params = {
        SkipCount: 0,
        MaxResultCount: 100
      };
      if (level == 0) {
        params.ParentId = 0;
      } else {
        params.ParentId = node.data.id;
      }
      GetAllArea(params).then((res) => {
        let arr = res.data.result.items.map((e) => ({ id: e.id, value: e.id, label: e.name, leaf: level >= 2 }));
        resolve(arr);
      });
    },
    getTableList() {
      this.tableLoading = true;
      let params = {
        ParentId: this.parentId,
        SkipCount: (this.queryForm.pageIndex - 1) * 10,
        MaxResultCount: this.queryForm.pageSize
      }
      let that = this;
      GetAllWarehouse(params).then((res) => {
        that.tableLoading = false;
        that.total = res.data.result.totalCount;
        res.data.result.items.forEach(x => {
          x.showDeliveryArea = false;
          x.deliveryAreaStr = null;
          x.showLoading = false;
        });
        that.tableList = res.data.result.items;
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    handleCurrentChange(val) {
      this.queryForm.pageIndex = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.getTableList();
    },
    search() {
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    empty() {
      this.queryForm.Name = null;
      this.queryForm.pageIndex = 1;
      this.queryForm.pageSize = 10;
      this.getTableList();
    },
    addWarehouse() {
      this.warehouseFormVisible = true;
      this.isEdit = false;
      this.warehouseForm = {
        name: null
      }
    },
    expWarehouseId() {},
    submitWarehouse() {
      let that = this;
      that.$refs.warehouseForm.validate((valid) => {
        if (valid) {
          that.$confirm("确认提交吗？", "提示", {
            closeOnClickModal: false,
          }).then(() => {
            that.submitLoading = true;
            let provinceInfo = this.selectArea[0];
            let cityInfo = this.selectArea[1];
            let districtInfo = this.selectArea[2];
            let params = {
              parentId: this.parentId,
              name: that.warehouseForm.name,
              provinceId: provinceInfo.value,
              province: provinceInfo.label,
              cityId: cityInfo.value,
              city: cityInfo.label,
              districtId: districtInfo.value,
              district: districtInfo.label,
              detailedAddress: that.warehouseForm.address
            };
            CreateWarehouse(params).then((res) => {
              that.submitLoading = false;
              if (res.data.success) {
                that.$message.success('新增成功');
                that.warehouseFormVisible = false;
                that.getTableList();
              } else {
                that.$message.error(res.data.msg);
              }
            });
          }).catch(() => {});
        }
      });
    },
    defaultChecked (keys) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        keys.forEach(key => {
          if (!this.$refs.tree.getNode(key).childNodes || !this.$refs.tree.getNode(key).childNodes.length) {
            arr.push(key)
          }
        })
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    areaSet(params) {
      let row = params.funcParams;
      this.areaSetFormVisible = true;

      this.tableLoading = true;
      let data = { Id: row.id };
      GetWarehouseDetail(data).then((res) => {
        this.tableLoading = false;
        if (res.data.success) {
          let checkdKeys = [];
          res.data.result.deliveryAreas.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          this.defaultChecked(checkdKeys);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submitAreaSet() {
      let checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
      var newObject = JSON.parse(JSON.stringify(checkedNodes));
      newObject.forEach(x => {
        if (x.children) {
          delete x.children
        }
      })
      this.checkedNodeList = newObject;
      let params = { 
        warehouseId: this.currentRow.id,
        deliveryAreas: this.checkedNodeList
      };
      this.tableLoading = true;
      UpdateDeliveryAreas(params).then((res) => {
        this.tableLoading = false;
        if (res.data.success) {
          this.$message.success('提交成功');
          this.areaSetFormVisible = false;
          this.getTableList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    delWarehouse(params) {
      let row = params.funcParams;
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
        closeOnClickModal: false,
      }).then(() => {
        this.tableLoading = true;
        let params = { Id: row.id };
        DeleteWarehouse(params).then((res) => {
          this.tableLoading = false;
          if (res.data.success) {
            this.$message.success('删除成功');
            this.getTableList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }).catch(() => {});
    }
  }
};
</script>
<style scoped>
#main-box
{
  width: 100%;
  height:100%;
  padding-top: 40px;
}
#btn-box
{
  position: fixed;
  height: 60px;
  top: 94px;
  padding-left: 20px;
  padding-top: 16px;
}
#content-box
{
  padding: 0 20px 20px 20px;
  width: 100%;
  height: 100%;
  overflow: auto;
}
#main-box /deep/ .el-pagination {
  padding: 10px 5px;
}
</style>
